export const routePermissionMap: any = {
  //Dashboard
  "/index": "Dashboard",
  "/admin-dashboard": "Dashboard",
  "/cms-lead-dashboard": "Dashboard",
  "/cms-deal-dashboard": "Dashboard",
  "/deals-dashboard": "Dashboard",
  "/leads-dashboard": "Dashboard",

  //Application
  "/application/chat": "Applications",
  "/application/todo-list": "Applications",
  "/application/todo": "Applications",
  "/application/file-manager": "Applications",

  //Projects

  "/projects-grid": "Projects",
  "/projects": "Projects",
  "/sprints": "Projects",
  "/tasks": "Projects",
  "/task-board": "Projects",

  //CRM

  "/companies-list": "Companies",
  "/companies-grid": "Companies",
  "/companies-details": "Companies",
  "/deals-grid": "Deals",
  "/deals-list": "Deals",
  "/deals-details": "Deals",
  "/leads-grid": "Leads",
  "/leads-list": "Leads",
  "/leads-details": "Leads",
  "/leads-queue": "Leads In Queue",
  "/leads-transfer": "Leads Transfer",
  "/deals-transfer": "Deals Transfer",
  "/live-call": "Live Call",
  "/leads-form": "Leads Form",
  "/webhook-integrations": "Webhook Integration",
  "/pipeline": "Pipelines",
  "/crm-settings": "CRM Settings",
  "/call-logs": "Call Logs",
  "/cms-bulk-upload": "Call Logs",

  // HRM
  "/employees": "Employees",
  "/employees-grid": "Employees",
  "/departments": "Employees",
  "/designations": "Employees",
  "/leaves": "Attendance (Admin)",
  "/leave-settings": "Attendance (Admin)",
  "/attendance-admin": "Attendance (Admin)",
  "/settings": "Attendance (Admin)",
  "/attendance-employee": "Attendance (Employee)",
  "/leaves-employee": "Attendance (Employee)",

  // Tickets
  "/tickets/ticket-list": "Tickets",
  "/ticket-categories": "Ticket Settings",

  // Assets
  "/asset-stocks": "Assets",
  "/assets": "Assets",
  "/asset-products": "Assets",
  "/asset-categories": "Assets",
  "/asset-locations": "Assets",
  "/assign-assets": "Assets",

  // Recruitment
  "/job-grid": "Jobs",
  "/candidates-grid": "Candidates",
  "/refferal": "Refferals",
};
